/**
 * module name - public
 * 项目标题栏、导航栏、公共组件、多语言、菜单、公共组件
 */

export default {
  namespaced: true,
  state: {
    //菜单展示状态
    menuState2: true, //routerViewState

    //路由返回icon展示状态
    tabBackIcon_state: true,

    //设备类型
    isPcAndPhone: "",
    //全局选择语言组件状态
    languageIsShow: false,
    //全局菜单展示状态
    menuState: false,
    //登陆后前往页面地址
    emailFromPath: "",
    //信用卡确认订单页返回返回到首页状态
    creditCard_backState: false,
    //确认订单后返回二次确认框
    payPageback_limit: false,
  },
  mutations: {
    set_menuState2(state, val) {
      state.menuState2 = val;
    },

    set_isPcAndPhone(state, val) {
      state.isPcAndPhone = val;
    },
    set_languageIsShow(state, val) {
      state.languageIsShow = val;
    },
    set_menuState(state, val) {
      state.menuState = val;
    },
    set_emailFromPath(state, val) {
      state.emailFromPath = val;
    },
    set_creditCard_backState(state, val) {
      state.creditCard_backState = val;
    },
    set_payPageback_limit(state, val) {
      state.payPageback_limit = val;
    },
    set_tabBackIcon_state(state, val) {
      state.tabBackIcon_state = val;
    },

    //初始化项目默认数据
    set_projectData(state) {
      state.menuState2 = true;
      state.tabBackIcon_state = true;
      state.languageIsShow = false;
      state.menuState = false;
      state.emailFromPath = false;
      state.creditCard_backState = false;
      state.payPageback_limit = false;
    },
  },
};
